module.exports = (__webpack_require__(75))(1);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/webpack/buildin/global.js from dll-reference vendor
// module id = 65
// module chunks = 0